export const Field = ({ label, en, error, children, name }) => (
  <div className="field">
    <label className="field-label" htmlFor={name}>
      <span className="font-hi">{label}</span> <span className="text-slate-400 font-normal">/ {en}</span>
      <span className="text-saffron"> *</span>
    </label>
    {children}
    {error && (
      <p className="field-error" data-testid={`error-${name}`}>{error}</p>
    )}
  </div>
);

export const CheckRow = ({ name, checked, onChange, error, children }) => (
  <div>
    <label className={`check-row ${checked ? "on" : ""} ${error ? "bad" : ""}`}>
      <input
        type="checkbox"
        id={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={`checkbox-${name}`}
      />
      <span className="text-sm text-slate-700">{children}</span>
    </label>
    {error && <p className="field-error" data-testid={`error-${name}`}>{error}</p>}
  </div>
);
